import { useRef } from 'react';

export function useCampaignBasicsRefs() {
  const campaignNameRef = useRef<HTMLInputElement>(null);
  const campaignStartDateRef = useRef<HTMLButtonElement>(null);
  const campaignEndDateRef = useRef<HTMLButtonElement>(null);

  return {
    campaignEndDateRef,
    campaignNameRef,
    campaignStartDateRef,
  };
}
